/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import { FormattedMessage } from 'react-intl';
import MeasurementReading from '../../shared/state/measurement-reading';
import Modal from '../../../../sharedmodules/state/modal';
import Product from '../../shared/state/product';
import ProductInfoPanel from '../../shared/components/product-info-panel/product-info-panel';
import PropTypes from 'prop-types';
import React from 'react';

const NewTransferHeader = (props) => (
    <section className="new-transfer-header">
        <h2>
            <FormattedMessage id="CHANGE_RESPONSIBLE_DEALER" />
        </h2>
        <ProductInfoPanel
            changeModalVisibility={props.changeModalVisibility}
            isAmountOfUseModalOpen={props.isAmountOfUseModalOpen}
            measurementReadings={props.measurementReadings}
            onAmountOfUseModalClose={props.onAmountOfUseModalClose}
            onAmountOfUseModalOpen={props.onAmountOfUseModalOpen}
            product={props.product}
            productStatusChangeModal={props.productStatusChangeModal}
            updateStatus={props.updateStatus}
        />
    </section>
);

NewTransferHeader.displayName = 'NewTransferHeader';
NewTransferHeader.propTypes = {
    changeModalVisibility: PropTypes.func.isRequired,
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onAmountOfUseModalClose: PropTypes.func.isRequired,
    onAmountOfUseModalOpen: PropTypes.func.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    productStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    updateStatus: PropTypes.func.isRequired,
};

export default NewTransferHeader;
